import PropTypes from "prop-types";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

import MDTypography from "shared/ui/Typography/MDTypography";
import MDBox from "shared/ui/Box/MDBox";

function ConfirmUnsavedChangesDialog({
  open,
  isSaving,
  errorMessage,
  onSaveAndContinue,
  onDiscard,
  onCancel,
}) {
  return (
    <Dialog
      open={open}
      onClose={isSaving ? undefined : onCancel}
      aria-labelledby="confirm-unsaved-changes"
      sx={{ zIndex: (theme) => theme.zIndex.modal + 2 }}
    >
      <DialogTitle id="confirm-unsaved-changes" sx={{ textAlign: "center" }}>
        Cambios sin guardar
      </DialogTitle>

      <DialogContent>
        <MDTypography variant="body2" mb={2} textAlign="center">
          Hay cambios sin guardar en la rutina actual.
        </MDTypography>

        <MDBox textAlign="center" mt={1}>
          <MDTypography variant="body2" color="text.secondary">
            ¿Qué quieres hacer?
          </MDTypography>
        </MDBox>

        {errorMessage && (
          <MDTypography variant="body2" color="error" mt={2} textAlign="center">
            {errorMessage}
          </MDTypography>
        )}
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", gap: 2 }}>
        <Button onClick={onCancel} disabled={isSaving} sx={{ minWidth: 150 }}>
          Cancelar
        </Button>

        <Button
          onClick={onDiscard}
          disabled={isSaving}
          color="error"
          variant="outlined"
          sx={{ minWidth: 150 }}
        >
          Descartar cambios
        </Button>

        <Button
          onClick={onSaveAndContinue}
          disabled={isSaving}
          variant="contained"
          color="primary"
          sx={{ minWidth: 150 }}
        >
          {isSaving ? "Guardando..." : "Guardar y continuar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmUnsavedChangesDialog.defaultProps = {
  errorMessage: "",
  isSaving: false,
};

ConfirmUnsavedChangesDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool,
  errorMessage: PropTypes.string,
  onSaveAndContinue: PropTypes.func.isRequired,
  onDiscard: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ConfirmUnsavedChangesDialog;
